module.exports = __webpack_public_path__ + "static/media/bannerHomepage.e360809d.jpg";